import apiClient from '../ApiClient';

export const fetchUserAverageRating = async (userId: number): Promise<any> => {
  const res = await apiClient.get(`users/${userId}/reviews/average`);

  return {
    totalReviews: res.data?.data?.total_reviews ?? 0,
    averageRating: res.data?.data?.average_rating ?? 0,
  };
};